function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { useLocation } from 'react-router-dom';
import { NavigationLink as RivendellNavigationLink, NavigationMenu as RivendellNavigationMenu } from '@nordlayer/rivendell-ui';
import { NAVIGATION_ITEM_TYPES } from './types';
import { isNavigationItemActive } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
var NavigationLink = function NavigationLink(_ref) {
    var prefix = _ref.prefix, href = _ref.href, label = _ref.label, dataTestId = _ref['data-testid'], _ref$size = _ref.size, size = _ref$size === void 0 ? 'md' : _ref$size;
    var location = useLocation();
    return /*#__PURE__*/ _jsx(RivendellNavigationLink, {
        prefix: prefix,
        "data-testid": dataTestId,
        href: href,
        isActive: isNavigationItemActive({
            currentPath: location.pathname,
            pathsToCompare: href ? [href] : undefined
        }),
        size: size,
        children: label
    });
};
var NavigationSubMenu = function NavigationSubMenu(_ref2) {
    var items = _ref2.items, prefix = _ref2.prefix, label = _ref2.label, dataTestId = _ref2['data-testid'];
    var location = useLocation();
    var childrenHrefs = items.map(function (_ref3) {
        var href = _ref3.href;
        return href;
    }).filter(Boolean);
    return /*#__PURE__*/ _jsx(RivendellNavigationMenu, {
        prefix: prefix,
        "data-testid": dataTestId,
        triggerChildren: label,
        isActive: isNavigationItemActive({
            currentPath: location.pathname,
            pathsToCompare: childrenHrefs
        }),
        children: items.map(function (child, index) {
            return /*#__PURE__*/ _jsx(NavigationLink, _objectSpread({}, child), index);
        })
    });
};
export var NavigationItem = function NavigationItem(_ref4) {
    var item = _ref4.item;
    if (item.type === NAVIGATION_ITEM_TYPES.link) {
        return /*#__PURE__*/ _jsx(NavigationLink, _objectSpread({}, item));
    }
    if (item.type === NAVIGATION_ITEM_TYPES.menu) {
        return /*#__PURE__*/ _jsx(NavigationSubMenu, _objectSpread({}, item));
    }
    return null;
};
